<div *ngIf="!gridData.rows || gridData.rows.length === 0">
    {{
        _i18n._11106_THERE_ARE_NO_RECENTLY_CLOSED_FOCUSES_FOR_THIS_PERFORMER
            | translate
    }}
</div>
<reusable-grid
    *ngIf="gridData.rows && gridData.rows.length > 0"
    [rendererOptions]="gridData.rendererOpts"
    [selectTemplate]="_selectTpl"
    [rowsTop]="gridData.gridRowsTop"
    [rows]="gridData.rows"
    [sortDefs]="gridData.sortDefs"
    (selectRow)="_selectRow($event)"
    selectType="single"
>
    <ng-template
        gridContent
        data-type="grid"
    >
        <div></div>
    </ng-template>

    <ng-template
        gridContent
        data-type="row"
        data-id="header"
    >
        <div></div>
    </ng-template>

    <ng-template
        gridContent
        data-type="row"
        data-id="content"
    >
        <div></div>
    </ng-template>

    <ng-template
        gridContent
        data-type="cell"
        data-id="header"
        let-c="c"
    >
        <div [ngSwitch]="c.id">
            <div *ngSwitchCase="_ColumnID.METRIC">
                {{ _i18n._713_METRIC | translate }}
            </div>
            <div *ngSwitchCase="_ColumnID.BEHAVIOUR">
                {{ _i18n._7334_BEHAVIOUR | translate }}
            </div>
            <div *ngSwitchCase="_ColumnID.TACTIC">
                {{ _i18n._7307_TACTIC | translate }}
            </div>
            <div *ngSwitchCase="_ColumnID.CURRENT_IMPROVEMENT">
                {{ _i18n._10062_PERCENT_IMPROVEMENT | translate }}
            </div>
            <div *ngSwitchCase="_ColumnID.DAYS_ACTIVE">
                <reusable-grid-sort
                    [gridSortDef]="gridData.sortDefs?.[0]"
                    [column]="c"
                    [isSorting]="gridData.sortDefs && gridData.sortDefs.length"
                    (sortClick)="sortGrid.emit($event)"
                >
                    {{ _i18n._9473_DAYS_ACTIVE | translate }}
                </reusable-grid-sort>
            </div>
        </div>
    </ng-template>

    <ng-template
        gridContent
        data-type="cell"
        data-id="content"
        let-c="c"
        let-l="l"
        let-r="r"
        let-ctx="ctx"
    >
        <div
            [ngSwitch]="c.id"
            [ngClass]="{ 'row-checked': ctx.checked }"
            (click)="ctx.clickRow()"
        >
            <div *ngSwitchCase="_ColumnID.METRIC">
                <cmps-checkbox
                    [variant]="ctx.checkboxVariant"
                    [checked]="ctx.checked"
                >
                    <reusable-grid-text
                        [ngStyle]="{ color: c.color ?? 'black' }"
                        [text]="ctx.metric"
                        [resizeSubject]="ctx.resizeSubject"
                    ></reusable-grid-text>
                </cmps-checkbox>
            </div>
            <div *ngSwitchCase="_ColumnID.BEHAVIOUR">
                <reusable-grid-text
                    [ngStyle]="{ color: c.color ?? 'black' }"
                    [text]="ctx.behaviour"
                    [resizeSubject]="ctx.resizeSubject"
                ></reusable-grid-text>
            </div>
            <div
                *ngSwitchCase="_ColumnID.TACTIC"
                class="tactic-cell"
            >
                <reusable-grid-text
                    class="tactic-name"
                    [ngStyle]="{ color: c.color ?? 'black' }"
                    [text]="ctx.tactic"
                    [resizeSubject]="ctx.resizeSubject"
                ></reusable-grid-text>
                <cmps-icon
                    *ngIf="r?.context?.ctx?.focus?.hasActiveCommitment"
                    class="tactic-icon"
                    svgIcon="alert-box"
                    [cmpsTooltipTrigger]="
                        _i18n._11110_FOCUS_ALREADY_USED_IN_ACTIVE_COMMITMENT
                            | translate
                    "
                ></cmps-icon>
            </div>
            <div *ngSwitchCase="_ColumnID.CURRENT_IMPROVEMENT">
                <reusable-grid-text
                    [ngStyle]="{ color: c.color ?? 'black' }"
                    class="text-center"
                    [text]="ctx.currentImprovement | cmpsPercent: '1.0-2'"
                    [resizeSubject]="ctx.resizeSubject"
                ></reusable-grid-text>
            </div>
            <div *ngSwitchCase="_ColumnID.DAYS_ACTIVE">
                <reusable-grid-text
                    [ngStyle]="{ color: c.color ?? 'black' }"
                    class="text-center"
                    [text]="ctx.daysActive?.toString()"
                    [resizeSubject]="ctx.resizeSubject"
                ></reusable-grid-text>
            </div>
        </div>
    </ng-template>
</reusable-grid>
